import { Box, Stack } from '@mantine/core';
import { TextSkeleton } from '@repo/foundations';
import { memo } from 'react';
import { AiChatHistoryBody } from './AiChatHistoryBody';

export const AiChatHistorySkeleton = memo(() => (
	<AiChatHistoryBody>
		<Box>
			<Stack spacing="xs">
				<TextSkeleton size="sm" width={110} />
				<TextSkeleton size="sm" />
				<TextSkeleton size="sm" />
				<TextSkeleton size="sm" />
			</Stack>
		</Box>
	</AiChatHistoryBody>
));
